<template>
  <div class="tag" :class="tagClasses">
    <svgicon v-if="icon" :class="[iconClasses, iconClass]" :name="icon"/>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
    iconClass: {
      type: String,
      default: null,
    },
  },

  computed: {
    iconClasses() {
      return this.icon && Object.keys(this.$slots).length === 0 ? '' : 'mr-1';
    },
    tagClasses() {
      return this.icon && Object.keys(this.$slots).length === 0
        ? 'tag-icon'
        : '';
    },
  },
};
</script>
